import {Option} from "@/models/helpers/Option";
import {userRoles} from "@/AppConfig";

export const fixRoleIdsInOptionList = (optionList:Array<Option>):Array<Option>=>{
    return optionList.map(el => userRoles.find(r => r.name === el.name) as Option).filter(el => el !== undefined);
};

/**
 * Returns the subset of userRoles that the current user is allowed to **see**
 * in the role-assignment UI.
 *
 * - 1AnvAdmin  → all roles (1AnvAdmin shown but disabled via isRoleDisabled)
 * - DataMaintainer → only PlantManager ("App User")
 * - otherwise  → empty (defensive fallback)
 */
export const getVisibleRoles = (currentUserRoles: string[]): Array<Option> => {
    if (currentUserRoles.includes("1AnvAdmin")) {
        return userRoles;
    }
    if (currentUserRoles.includes("DataMaintainer")) {
        return userRoles.filter(r => r.roleName === "PlantManager");
    }
    return [];
};

/**
 * Roles that must never be toggled in the UI (shown as disabled checkbox).
 * Currently only "1AnvAdmin" — can only be granted/revoked directly in the DB.
 */
export const isRoleDisabled = (roleName: string): boolean => {
    return roleName === "1AnvAdmin";
};